import React from 'react';
import { Link as RDLink } from 'react-router-dom';
import styled from 'styled-components';
import colors from './colors';

export const Base = styled.p`
  font-family: 'CircularStd';
  font-weight: ${({ thickness }) => (thickness || 'normal')};
  text-align: ${({ align }) => (align || 'left')};
  cursor: default;
  ${({ primary }) => (primary && `color: ${colors.Primary}`)};
  ${({ secondary }) => (secondary && `color: ${colors.Secondary}`)};
  ${({ align }) => `text-align: ${align || 'left'}`};
  color: ${({ txtcolor }) => (txtcolor || colors.Gray)} !important;
  margin-top: 0;
  margin-bottom: 1em;
`;

export const Small = styled(Base)`
  font-size: 0.7rem;
  color: ${({ txtcolor }) => (txtcolor || colors.DarkGray)} !important;
`;

export const Huge = styled(Base)`
  font-size: 2rem;
  font-weight: bold;
  color: ${({ txtcolor }) => (txtcolor || colors.DarkGray)} !important;
`;

export const Title = styled(Base)`
  font-size: 1.5rem;
  color: ${({ txtcolor }) => (txtcolor || colors.DarkGray)} !important;
`;

export const Subtitle = styled(Base)`
  font-size: 1.2rem;
  color: ${({ txtcolor }) => (txtcolor || colors.DarkGray)} !important;
`;

export const Caption = styled(Base)`
  color: ${colors.LightGray};
`;

export const Disabled = styled(Base)`
  color: ${colors.LighterGray};
`;

export const Label = styled.label`
  display: block;
  margin: 15px 0;
`;

export const Link = ({ children, ...props }) => (
  <RDLink
    style={{
      display: 'block',
      textDecoration: 'none',
    }}
    {...props}
  >
    { children }
  </RDLink>
);

export const DT = styled.dt`
  color: ${colors.LightGray};
  text-transform: uppercase;
`;
